import { type PagePathnameSlice } from '../../../../../api'

export const pagePathnameSlice1: PagePathnameSlice = {
  __typename: 'PagePathnameSlice',
  id: 'UGFnZTozOWZkNDcyZS03N2QxLTRjZDItOGE3Yi02ZTQ2MDU3ODgxNzM=',
  pathname: 'about',
}
